import React, { useContext } from "react";
import { SnackbarContext } from "../../../config/hooks/use-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVolumeHigh,
  faCirclePlay,
  faTowerCell,
} from "@fortawesome/free-solid-svg-icons";
import { servie, backservice } from "../../../assets/images";
import CustomButton from "../../../shared/custom-button/custom-button";
import "./services.css";

const Service = () => {
  const snackBar = useContext(SnackbarContext);

  return (
    <div className="services-container" id="about">
      <div className="services-header">
        <div className="services-badge">Qualité Premium</div>
        <h2 className="services-title font-montserrat_medium mb-3">
          Cours filmés en HD, diffusés en direct
        </h2>
        <p className="services-description">
          Apprenez en ligne comme si vous y étiez ! Des cours en direct avec
          vidéo et audio haute qualité pour une expérience immersive et
          interactive. Engagement accru, meilleure rétention et accessibilité.
        </p>
        
        <CustomButton
          text={"Visiter des cours"}
          onClick={() => 
            snackBar?.showMessage(
              "Détails du cours",
              "Veuillez vous authentifier pour accéder aux détails du cours.", 
              "info"
            )
          }
          className="services-btn"
          width="w-auto"
        />
      </div>
      
      <div className="services-visuals">
        <div className="services-image-wrapper">
          <div className="services-glow"></div>
          <img
            src={servie}
            alt="Enseignante avec élève"
            className="services-main-img"
          />
          
          <div className="floating-feature feature-live">
            <div className="feature-icon-wrapper live-bg">
              <FontAwesomeIcon icon={faTowerCell} className="feature-icon" />
            </div>
            <span>Cours en direct</span>
          </div>
          
          <div className="floating-feature feature-recorded">
            <div className="feature-icon-wrapper recorded-bg">
              <FontAwesomeIcon icon={faCirclePlay} className="feature-icon" />
            </div>
            <span>Cours enregistrés</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;